module.exports = __webpack_public_path__ + "img/key-pass.cbd978a0.svg";